/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SecureRouteImport } from './routes/_secure'
import { Route as SecureWorkspaceInviteRouteImport } from './routes/_secure/workspace-invite'
import { Route as SecureSettingsRouteImport } from './routes/_secure/settings'
import { Route as SecureMainRouteImport } from './routes/_secure/_main'
import { Route as SecureSettingsIndexRouteImport } from './routes/_secure/settings/index'
import { Route as SecureMainIndexRouteImport } from './routes/_secure/_main/index'
import { Route as SecureSlackOauthRouteImport } from './routes/_secure/slack/oauth'
import { Route as SecureSlackConfirmRouteImport } from './routes/_secure/slack/confirm'
import { Route as SecureSettingsUsageRouteImport } from './routes/_secure/settings/usage'
import { Route as SecureSettingsTeamRouteImport } from './routes/_secure/settings/team'
import { Route as SecureSettingsProfileRouteImport } from './routes/_secure/settings/profile'
import { Route as SecureSettingsPreferencesRouteImport } from './routes/_secure/settings/preferences'
import { Route as SecureSettingsGeneralRouteImport } from './routes/_secure/settings/general'
import { Route as SecureSettingsApiKeyRouteImport } from './routes/_secure/settings/api-key'
import { Route as SecureSettingsAdminRouteImport } from './routes/_secure/settings/admin'
import { Route as SecureSettingsSplatRouteImport } from './routes/_secure/settings/$'
import { Route as SecureProjectsProjectIdRouteImport } from './routes/_secure/projects/$projectId'
import { Route as SecureMainProjectsRouteImport } from './routes/_secure/_main/projects'
import { Route as SecureProjectsProjectIdIndexRouteImport } from './routes/_secure/projects/$projectId/index'
import { Route as SecureProjectsProjectIdSettingsRouteImport } from './routes/_secure/projects/$projectId/settings'
import { Route as SecureProjectsProjectIdSettingsIndexRouteImport } from './routes/_secure/projects/$projectId/settings/index'
import { Route as SecureProjectsProjectIdObjectsIndexRouteImport } from './routes/_secure/projects/$projectId/objects/index'
import { Route as SecureProjectsProjectIdGraphIndexRouteImport } from './routes/_secure/projects/$projectId/graph/index'
import { Route as SecureProjectsProjectIdSettingsSyncsRouteImport } from './routes/_secure/projects/$projectId/settings/syncs'
import { Route as SecureProjectsProjectIdSettingsSourcesRouteImport } from './routes/_secure/projects/$projectId/settings/sources'
import { Route as SecureProjectsProjectIdSettingsGeneralRouteImport } from './routes/_secure/projects/$projectId/settings/general'
import { Route as SecureProjectsProjectIdSettingsDangerRouteImport } from './routes/_secure/projects/$projectId/settings/danger'
import { Route as SecureProjectsProjectIdSettingsConfigurationRouteImport } from './routes/_secure/projects/$projectId/settings/configuration'
import { Route as SecureProjectsProjectIdSettingsArtifactsRouteImport } from './routes/_secure/projects/$projectId/settings/artifacts'

const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SecureRoute = SecureRouteImport.update({
  id: '/_secure',
  getParentRoute: () => rootRouteImport,
} as any)
const SecureWorkspaceInviteRoute = SecureWorkspaceInviteRouteImport.update({
  id: '/workspace-invite',
  path: '/workspace-invite',
  getParentRoute: () => SecureRoute,
} as any)
const SecureSettingsRoute = SecureSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => SecureRoute,
} as any)
const SecureMainRoute = SecureMainRouteImport.update({
  id: '/_main',
  getParentRoute: () => SecureRoute,
} as any)
const SecureSettingsIndexRoute = SecureSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SecureSettingsRoute,
} as any)
const SecureMainIndexRoute = SecureMainIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SecureMainRoute,
} as any)
const SecureSlackOauthRoute = SecureSlackOauthRouteImport.update({
  id: '/slack/oauth',
  path: '/slack/oauth',
  getParentRoute: () => SecureRoute,
} as any)
const SecureSlackConfirmRoute = SecureSlackConfirmRouteImport.update({
  id: '/slack/confirm',
  path: '/slack/confirm',
  getParentRoute: () => SecureRoute,
} as any)
const SecureSettingsUsageRoute = SecureSettingsUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => SecureSettingsRoute,
} as any)
const SecureSettingsTeamRoute = SecureSettingsTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => SecureSettingsRoute,
} as any)
const SecureSettingsProfileRoute = SecureSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => SecureSettingsRoute,
} as any)
const SecureSettingsPreferencesRoute =
  SecureSettingsPreferencesRouteImport.update({
    id: '/preferences',
    path: '/preferences',
    getParentRoute: () => SecureSettingsRoute,
  } as any)
const SecureSettingsGeneralRoute = SecureSettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => SecureSettingsRoute,
} as any)
const SecureSettingsApiKeyRoute = SecureSettingsApiKeyRouteImport.update({
  id: '/api-key',
  path: '/api-key',
  getParentRoute: () => SecureSettingsRoute,
} as any)
const SecureSettingsAdminRoute = SecureSettingsAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => SecureSettingsRoute,
} as any)
const SecureSettingsSplatRoute = SecureSettingsSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => SecureSettingsRoute,
} as any)
const SecureProjectsProjectIdRoute = SecureProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => SecureRoute,
} as any)
const SecureMainProjectsRoute = SecureMainProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => SecureMainRoute,
} as any)
const SecureProjectsProjectIdIndexRoute =
  SecureProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecureProjectsProjectIdRoute,
  } as any)
const SecureProjectsProjectIdSettingsRoute =
  SecureProjectsProjectIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => SecureProjectsProjectIdRoute,
  } as any)
const SecureProjectsProjectIdSettingsIndexRoute =
  SecureProjectsProjectIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecureProjectsProjectIdSettingsRoute,
  } as any)
const SecureProjectsProjectIdObjectsIndexRoute =
  SecureProjectsProjectIdObjectsIndexRouteImport.update({
    id: '/objects/',
    path: '/objects/',
    getParentRoute: () => SecureProjectsProjectIdRoute,
  } as any)
const SecureProjectsProjectIdGraphIndexRoute =
  SecureProjectsProjectIdGraphIndexRouteImport.update({
    id: '/graph/',
    path: '/graph/',
    getParentRoute: () => SecureProjectsProjectIdRoute,
  } as any)
const SecureProjectsProjectIdSettingsSyncsRoute =
  SecureProjectsProjectIdSettingsSyncsRouteImport.update({
    id: '/syncs',
    path: '/syncs',
    getParentRoute: () => SecureProjectsProjectIdSettingsRoute,
  } as any)
const SecureProjectsProjectIdSettingsSourcesRoute =
  SecureProjectsProjectIdSettingsSourcesRouteImport.update({
    id: '/sources',
    path: '/sources',
    getParentRoute: () => SecureProjectsProjectIdSettingsRoute,
  } as any)
const SecureProjectsProjectIdSettingsGeneralRoute =
  SecureProjectsProjectIdSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => SecureProjectsProjectIdSettingsRoute,
  } as any)
const SecureProjectsProjectIdSettingsDangerRoute =
  SecureProjectsProjectIdSettingsDangerRouteImport.update({
    id: '/danger',
    path: '/danger',
    getParentRoute: () => SecureProjectsProjectIdSettingsRoute,
  } as any)
const SecureProjectsProjectIdSettingsConfigurationRoute =
  SecureProjectsProjectIdSettingsConfigurationRouteImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => SecureProjectsProjectIdSettingsRoute,
  } as any)
const SecureProjectsProjectIdSettingsArtifactsRoute =
  SecureProjectsProjectIdSettingsArtifactsRouteImport.update({
    id: '/artifacts',
    path: '/artifacts',
    getParentRoute: () => SecureProjectsProjectIdSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/settings': typeof SecureSettingsRouteWithChildren
  '/workspace-invite': typeof SecureWorkspaceInviteRoute
  '/projects': typeof SecureMainProjectsRoute
  '/projects/$projectId': typeof SecureProjectsProjectIdRouteWithChildren
  '/settings/$': typeof SecureSettingsSplatRoute
  '/settings/admin': typeof SecureSettingsAdminRoute
  '/settings/api-key': typeof SecureSettingsApiKeyRoute
  '/settings/general': typeof SecureSettingsGeneralRoute
  '/settings/preferences': typeof SecureSettingsPreferencesRoute
  '/settings/profile': typeof SecureSettingsProfileRoute
  '/settings/team': typeof SecureSettingsTeamRoute
  '/settings/usage': typeof SecureSettingsUsageRoute
  '/slack/confirm': typeof SecureSlackConfirmRoute
  '/slack/oauth': typeof SecureSlackOauthRoute
  '/': typeof SecureMainIndexRoute
  '/settings/': typeof SecureSettingsIndexRoute
  '/projects/$projectId/settings': typeof SecureProjectsProjectIdSettingsRouteWithChildren
  '/projects/$projectId/': typeof SecureProjectsProjectIdIndexRoute
  '/projects/$projectId/settings/artifacts': typeof SecureProjectsProjectIdSettingsArtifactsRoute
  '/projects/$projectId/settings/configuration': typeof SecureProjectsProjectIdSettingsConfigurationRoute
  '/projects/$projectId/settings/danger': typeof SecureProjectsProjectIdSettingsDangerRoute
  '/projects/$projectId/settings/general': typeof SecureProjectsProjectIdSettingsGeneralRoute
  '/projects/$projectId/settings/sources': typeof SecureProjectsProjectIdSettingsSourcesRoute
  '/projects/$projectId/settings/syncs': typeof SecureProjectsProjectIdSettingsSyncsRoute
  '/projects/$projectId/graph': typeof SecureProjectsProjectIdGraphIndexRoute
  '/projects/$projectId/objects': typeof SecureProjectsProjectIdObjectsIndexRoute
  '/projects/$projectId/settings/': typeof SecureProjectsProjectIdSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/workspace-invite': typeof SecureWorkspaceInviteRoute
  '/projects': typeof SecureMainProjectsRoute
  '/settings/$': typeof SecureSettingsSplatRoute
  '/settings/admin': typeof SecureSettingsAdminRoute
  '/settings/api-key': typeof SecureSettingsApiKeyRoute
  '/settings/general': typeof SecureSettingsGeneralRoute
  '/settings/preferences': typeof SecureSettingsPreferencesRoute
  '/settings/profile': typeof SecureSettingsProfileRoute
  '/settings/team': typeof SecureSettingsTeamRoute
  '/settings/usage': typeof SecureSettingsUsageRoute
  '/slack/confirm': typeof SecureSlackConfirmRoute
  '/slack/oauth': typeof SecureSlackOauthRoute
  '/': typeof SecureMainIndexRoute
  '/settings': typeof SecureSettingsIndexRoute
  '/projects/$projectId': typeof SecureProjectsProjectIdIndexRoute
  '/projects/$projectId/settings/artifacts': typeof SecureProjectsProjectIdSettingsArtifactsRoute
  '/projects/$projectId/settings/configuration': typeof SecureProjectsProjectIdSettingsConfigurationRoute
  '/projects/$projectId/settings/danger': typeof SecureProjectsProjectIdSettingsDangerRoute
  '/projects/$projectId/settings/general': typeof SecureProjectsProjectIdSettingsGeneralRoute
  '/projects/$projectId/settings/sources': typeof SecureProjectsProjectIdSettingsSourcesRoute
  '/projects/$projectId/settings/syncs': typeof SecureProjectsProjectIdSettingsSyncsRoute
  '/projects/$projectId/graph': typeof SecureProjectsProjectIdGraphIndexRoute
  '/projects/$projectId/objects': typeof SecureProjectsProjectIdObjectsIndexRoute
  '/projects/$projectId/settings': typeof SecureProjectsProjectIdSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_secure': typeof SecureRouteWithChildren
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/_secure/_main': typeof SecureMainRouteWithChildren
  '/_secure/settings': typeof SecureSettingsRouteWithChildren
  '/_secure/workspace-invite': typeof SecureWorkspaceInviteRoute
  '/_secure/_main/projects': typeof SecureMainProjectsRoute
  '/_secure/projects/$projectId': typeof SecureProjectsProjectIdRouteWithChildren
  '/_secure/settings/$': typeof SecureSettingsSplatRoute
  '/_secure/settings/admin': typeof SecureSettingsAdminRoute
  '/_secure/settings/api-key': typeof SecureSettingsApiKeyRoute
  '/_secure/settings/general': typeof SecureSettingsGeneralRoute
  '/_secure/settings/preferences': typeof SecureSettingsPreferencesRoute
  '/_secure/settings/profile': typeof SecureSettingsProfileRoute
  '/_secure/settings/team': typeof SecureSettingsTeamRoute
  '/_secure/settings/usage': typeof SecureSettingsUsageRoute
  '/_secure/slack/confirm': typeof SecureSlackConfirmRoute
  '/_secure/slack/oauth': typeof SecureSlackOauthRoute
  '/_secure/_main/': typeof SecureMainIndexRoute
  '/_secure/settings/': typeof SecureSettingsIndexRoute
  '/_secure/projects/$projectId/settings': typeof SecureProjectsProjectIdSettingsRouteWithChildren
  '/_secure/projects/$projectId/': typeof SecureProjectsProjectIdIndexRoute
  '/_secure/projects/$projectId/settings/artifacts': typeof SecureProjectsProjectIdSettingsArtifactsRoute
  '/_secure/projects/$projectId/settings/configuration': typeof SecureProjectsProjectIdSettingsConfigurationRoute
  '/_secure/projects/$projectId/settings/danger': typeof SecureProjectsProjectIdSettingsDangerRoute
  '/_secure/projects/$projectId/settings/general': typeof SecureProjectsProjectIdSettingsGeneralRoute
  '/_secure/projects/$projectId/settings/sources': typeof SecureProjectsProjectIdSettingsSourcesRoute
  '/_secure/projects/$projectId/settings/syncs': typeof SecureProjectsProjectIdSettingsSyncsRoute
  '/_secure/projects/$projectId/graph/': typeof SecureProjectsProjectIdGraphIndexRoute
  '/_secure/projects/$projectId/objects/': typeof SecureProjectsProjectIdObjectsIndexRoute
  '/_secure/projects/$projectId/settings/': typeof SecureProjectsProjectIdSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/login'
    | '/onboarding'
    | '/settings'
    | '/workspace-invite'
    | '/projects'
    | '/projects/$projectId'
    | '/settings/$'
    | '/settings/admin'
    | '/settings/api-key'
    | '/settings/general'
    | '/settings/preferences'
    | '/settings/profile'
    | '/settings/team'
    | '/settings/usage'
    | '/slack/confirm'
    | '/slack/oauth'
    | '/'
    | '/settings/'
    | '/projects/$projectId/settings'
    | '/projects/$projectId/'
    | '/projects/$projectId/settings/artifacts'
    | '/projects/$projectId/settings/configuration'
    | '/projects/$projectId/settings/danger'
    | '/projects/$projectId/settings/general'
    | '/projects/$projectId/settings/sources'
    | '/projects/$projectId/settings/syncs'
    | '/projects/$projectId/graph'
    | '/projects/$projectId/objects'
    | '/projects/$projectId/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/onboarding'
    | '/workspace-invite'
    | '/projects'
    | '/settings/$'
    | '/settings/admin'
    | '/settings/api-key'
    | '/settings/general'
    | '/settings/preferences'
    | '/settings/profile'
    | '/settings/team'
    | '/settings/usage'
    | '/slack/confirm'
    | '/slack/oauth'
    | '/'
    | '/settings'
    | '/projects/$projectId'
    | '/projects/$projectId/settings/artifacts'
    | '/projects/$projectId/settings/configuration'
    | '/projects/$projectId/settings/danger'
    | '/projects/$projectId/settings/general'
    | '/projects/$projectId/settings/sources'
    | '/projects/$projectId/settings/syncs'
    | '/projects/$projectId/graph'
    | '/projects/$projectId/objects'
    | '/projects/$projectId/settings'
  id:
    | '__root__'
    | '/_secure'
    | '/login'
    | '/onboarding'
    | '/_secure/_main'
    | '/_secure/settings'
    | '/_secure/workspace-invite'
    | '/_secure/_main/projects'
    | '/_secure/projects/$projectId'
    | '/_secure/settings/$'
    | '/_secure/settings/admin'
    | '/_secure/settings/api-key'
    | '/_secure/settings/general'
    | '/_secure/settings/preferences'
    | '/_secure/settings/profile'
    | '/_secure/settings/team'
    | '/_secure/settings/usage'
    | '/_secure/slack/confirm'
    | '/_secure/slack/oauth'
    | '/_secure/_main/'
    | '/_secure/settings/'
    | '/_secure/projects/$projectId/settings'
    | '/_secure/projects/$projectId/'
    | '/_secure/projects/$projectId/settings/artifacts'
    | '/_secure/projects/$projectId/settings/configuration'
    | '/_secure/projects/$projectId/settings/danger'
    | '/_secure/projects/$projectId/settings/general'
    | '/_secure/projects/$projectId/settings/sources'
    | '/_secure/projects/$projectId/settings/syncs'
    | '/_secure/projects/$projectId/graph/'
    | '/_secure/projects/$projectId/objects/'
    | '/_secure/projects/$projectId/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SecureRoute: typeof SecureRouteWithChildren
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_secure': {
      id: '/_secure'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof SecureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_secure/workspace-invite': {
      id: '/_secure/workspace-invite'
      path: '/workspace-invite'
      fullPath: '/workspace-invite'
      preLoaderRoute: typeof SecureWorkspaceInviteRouteImport
      parentRoute: typeof SecureRoute
    }
    '/_secure/settings': {
      id: '/_secure/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SecureSettingsRouteImport
      parentRoute: typeof SecureRoute
    }
    '/_secure/_main': {
      id: '/_secure/_main'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof SecureMainRouteImport
      parentRoute: typeof SecureRoute
    }
    '/_secure/settings/': {
      id: '/_secure/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SecureSettingsIndexRouteImport
      parentRoute: typeof SecureSettingsRoute
    }
    '/_secure/_main/': {
      id: '/_secure/_main/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof SecureMainIndexRouteImport
      parentRoute: typeof SecureMainRoute
    }
    '/_secure/slack/oauth': {
      id: '/_secure/slack/oauth'
      path: '/slack/oauth'
      fullPath: '/slack/oauth'
      preLoaderRoute: typeof SecureSlackOauthRouteImport
      parentRoute: typeof SecureRoute
    }
    '/_secure/slack/confirm': {
      id: '/_secure/slack/confirm'
      path: '/slack/confirm'
      fullPath: '/slack/confirm'
      preLoaderRoute: typeof SecureSlackConfirmRouteImport
      parentRoute: typeof SecureRoute
    }
    '/_secure/settings/usage': {
      id: '/_secure/settings/usage'
      path: '/usage'
      fullPath: '/settings/usage'
      preLoaderRoute: typeof SecureSettingsUsageRouteImport
      parentRoute: typeof SecureSettingsRoute
    }
    '/_secure/settings/team': {
      id: '/_secure/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof SecureSettingsTeamRouteImport
      parentRoute: typeof SecureSettingsRoute
    }
    '/_secure/settings/profile': {
      id: '/_secure/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof SecureSettingsProfileRouteImport
      parentRoute: typeof SecureSettingsRoute
    }
    '/_secure/settings/preferences': {
      id: '/_secure/settings/preferences'
      path: '/preferences'
      fullPath: '/settings/preferences'
      preLoaderRoute: typeof SecureSettingsPreferencesRouteImport
      parentRoute: typeof SecureSettingsRoute
    }
    '/_secure/settings/general': {
      id: '/_secure/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SecureSettingsGeneralRouteImport
      parentRoute: typeof SecureSettingsRoute
    }
    '/_secure/settings/api-key': {
      id: '/_secure/settings/api-key'
      path: '/api-key'
      fullPath: '/settings/api-key'
      preLoaderRoute: typeof SecureSettingsApiKeyRouteImport
      parentRoute: typeof SecureSettingsRoute
    }
    '/_secure/settings/admin': {
      id: '/_secure/settings/admin'
      path: '/admin'
      fullPath: '/settings/admin'
      preLoaderRoute: typeof SecureSettingsAdminRouteImport
      parentRoute: typeof SecureSettingsRoute
    }
    '/_secure/settings/$': {
      id: '/_secure/settings/$'
      path: '/$'
      fullPath: '/settings/$'
      preLoaderRoute: typeof SecureSettingsSplatRouteImport
      parentRoute: typeof SecureSettingsRoute
    }
    '/_secure/projects/$projectId': {
      id: '/_secure/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof SecureProjectsProjectIdRouteImport
      parentRoute: typeof SecureRoute
    }
    '/_secure/_main/projects': {
      id: '/_secure/_main/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof SecureMainProjectsRouteImport
      parentRoute: typeof SecureMainRoute
    }
    '/_secure/projects/$projectId/': {
      id: '/_secure/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof SecureProjectsProjectIdIndexRouteImport
      parentRoute: typeof SecureProjectsProjectIdRoute
    }
    '/_secure/projects/$projectId/settings': {
      id: '/_secure/projects/$projectId/settings'
      path: '/settings'
      fullPath: '/projects/$projectId/settings'
      preLoaderRoute: typeof SecureProjectsProjectIdSettingsRouteImport
      parentRoute: typeof SecureProjectsProjectIdRoute
    }
    '/_secure/projects/$projectId/settings/': {
      id: '/_secure/projects/$projectId/settings/'
      path: '/'
      fullPath: '/projects/$projectId/settings/'
      preLoaderRoute: typeof SecureProjectsProjectIdSettingsIndexRouteImport
      parentRoute: typeof SecureProjectsProjectIdSettingsRoute
    }
    '/_secure/projects/$projectId/objects/': {
      id: '/_secure/projects/$projectId/objects/'
      path: '/objects'
      fullPath: '/projects/$projectId/objects'
      preLoaderRoute: typeof SecureProjectsProjectIdObjectsIndexRouteImport
      parentRoute: typeof SecureProjectsProjectIdRoute
    }
    '/_secure/projects/$projectId/graph/': {
      id: '/_secure/projects/$projectId/graph/'
      path: '/graph'
      fullPath: '/projects/$projectId/graph'
      preLoaderRoute: typeof SecureProjectsProjectIdGraphIndexRouteImport
      parentRoute: typeof SecureProjectsProjectIdRoute
    }
    '/_secure/projects/$projectId/settings/syncs': {
      id: '/_secure/projects/$projectId/settings/syncs'
      path: '/syncs'
      fullPath: '/projects/$projectId/settings/syncs'
      preLoaderRoute: typeof SecureProjectsProjectIdSettingsSyncsRouteImport
      parentRoute: typeof SecureProjectsProjectIdSettingsRoute
    }
    '/_secure/projects/$projectId/settings/sources': {
      id: '/_secure/projects/$projectId/settings/sources'
      path: '/sources'
      fullPath: '/projects/$projectId/settings/sources'
      preLoaderRoute: typeof SecureProjectsProjectIdSettingsSourcesRouteImport
      parentRoute: typeof SecureProjectsProjectIdSettingsRoute
    }
    '/_secure/projects/$projectId/settings/general': {
      id: '/_secure/projects/$projectId/settings/general'
      path: '/general'
      fullPath: '/projects/$projectId/settings/general'
      preLoaderRoute: typeof SecureProjectsProjectIdSettingsGeneralRouteImport
      parentRoute: typeof SecureProjectsProjectIdSettingsRoute
    }
    '/_secure/projects/$projectId/settings/danger': {
      id: '/_secure/projects/$projectId/settings/danger'
      path: '/danger'
      fullPath: '/projects/$projectId/settings/danger'
      preLoaderRoute: typeof SecureProjectsProjectIdSettingsDangerRouteImport
      parentRoute: typeof SecureProjectsProjectIdSettingsRoute
    }
    '/_secure/projects/$projectId/settings/configuration': {
      id: '/_secure/projects/$projectId/settings/configuration'
      path: '/configuration'
      fullPath: '/projects/$projectId/settings/configuration'
      preLoaderRoute: typeof SecureProjectsProjectIdSettingsConfigurationRouteImport
      parentRoute: typeof SecureProjectsProjectIdSettingsRoute
    }
    '/_secure/projects/$projectId/settings/artifacts': {
      id: '/_secure/projects/$projectId/settings/artifacts'
      path: '/artifacts'
      fullPath: '/projects/$projectId/settings/artifacts'
      preLoaderRoute: typeof SecureProjectsProjectIdSettingsArtifactsRouteImport
      parentRoute: typeof SecureProjectsProjectIdSettingsRoute
    }
  }
}

interface SecureMainRouteChildren {
  SecureMainProjectsRoute: typeof SecureMainProjectsRoute
  SecureMainIndexRoute: typeof SecureMainIndexRoute
}

const SecureMainRouteChildren: SecureMainRouteChildren = {
  SecureMainProjectsRoute: SecureMainProjectsRoute,
  SecureMainIndexRoute: SecureMainIndexRoute,
}

const SecureMainRouteWithChildren = SecureMainRoute._addFileChildren(
  SecureMainRouteChildren,
)

interface SecureSettingsRouteChildren {
  SecureSettingsSplatRoute: typeof SecureSettingsSplatRoute
  SecureSettingsAdminRoute: typeof SecureSettingsAdminRoute
  SecureSettingsApiKeyRoute: typeof SecureSettingsApiKeyRoute
  SecureSettingsGeneralRoute: typeof SecureSettingsGeneralRoute
  SecureSettingsPreferencesRoute: typeof SecureSettingsPreferencesRoute
  SecureSettingsProfileRoute: typeof SecureSettingsProfileRoute
  SecureSettingsTeamRoute: typeof SecureSettingsTeamRoute
  SecureSettingsUsageRoute: typeof SecureSettingsUsageRoute
  SecureSettingsIndexRoute: typeof SecureSettingsIndexRoute
}

const SecureSettingsRouteChildren: SecureSettingsRouteChildren = {
  SecureSettingsSplatRoute: SecureSettingsSplatRoute,
  SecureSettingsAdminRoute: SecureSettingsAdminRoute,
  SecureSettingsApiKeyRoute: SecureSettingsApiKeyRoute,
  SecureSettingsGeneralRoute: SecureSettingsGeneralRoute,
  SecureSettingsPreferencesRoute: SecureSettingsPreferencesRoute,
  SecureSettingsProfileRoute: SecureSettingsProfileRoute,
  SecureSettingsTeamRoute: SecureSettingsTeamRoute,
  SecureSettingsUsageRoute: SecureSettingsUsageRoute,
  SecureSettingsIndexRoute: SecureSettingsIndexRoute,
}

const SecureSettingsRouteWithChildren = SecureSettingsRoute._addFileChildren(
  SecureSettingsRouteChildren,
)

interface SecureProjectsProjectIdSettingsRouteChildren {
  SecureProjectsProjectIdSettingsArtifactsRoute: typeof SecureProjectsProjectIdSettingsArtifactsRoute
  SecureProjectsProjectIdSettingsConfigurationRoute: typeof SecureProjectsProjectIdSettingsConfigurationRoute
  SecureProjectsProjectIdSettingsDangerRoute: typeof SecureProjectsProjectIdSettingsDangerRoute
  SecureProjectsProjectIdSettingsGeneralRoute: typeof SecureProjectsProjectIdSettingsGeneralRoute
  SecureProjectsProjectIdSettingsSourcesRoute: typeof SecureProjectsProjectIdSettingsSourcesRoute
  SecureProjectsProjectIdSettingsSyncsRoute: typeof SecureProjectsProjectIdSettingsSyncsRoute
  SecureProjectsProjectIdSettingsIndexRoute: typeof SecureProjectsProjectIdSettingsIndexRoute
}

const SecureProjectsProjectIdSettingsRouteChildren: SecureProjectsProjectIdSettingsRouteChildren =
  {
    SecureProjectsProjectIdSettingsArtifactsRoute:
      SecureProjectsProjectIdSettingsArtifactsRoute,
    SecureProjectsProjectIdSettingsConfigurationRoute:
      SecureProjectsProjectIdSettingsConfigurationRoute,
    SecureProjectsProjectIdSettingsDangerRoute:
      SecureProjectsProjectIdSettingsDangerRoute,
    SecureProjectsProjectIdSettingsGeneralRoute:
      SecureProjectsProjectIdSettingsGeneralRoute,
    SecureProjectsProjectIdSettingsSourcesRoute:
      SecureProjectsProjectIdSettingsSourcesRoute,
    SecureProjectsProjectIdSettingsSyncsRoute:
      SecureProjectsProjectIdSettingsSyncsRoute,
    SecureProjectsProjectIdSettingsIndexRoute:
      SecureProjectsProjectIdSettingsIndexRoute,
  }

const SecureProjectsProjectIdSettingsRouteWithChildren =
  SecureProjectsProjectIdSettingsRoute._addFileChildren(
    SecureProjectsProjectIdSettingsRouteChildren,
  )

interface SecureProjectsProjectIdRouteChildren {
  SecureProjectsProjectIdSettingsRoute: typeof SecureProjectsProjectIdSettingsRouteWithChildren
  SecureProjectsProjectIdIndexRoute: typeof SecureProjectsProjectIdIndexRoute
  SecureProjectsProjectIdGraphIndexRoute: typeof SecureProjectsProjectIdGraphIndexRoute
  SecureProjectsProjectIdObjectsIndexRoute: typeof SecureProjectsProjectIdObjectsIndexRoute
}

const SecureProjectsProjectIdRouteChildren: SecureProjectsProjectIdRouteChildren =
  {
    SecureProjectsProjectIdSettingsRoute:
      SecureProjectsProjectIdSettingsRouteWithChildren,
    SecureProjectsProjectIdIndexRoute: SecureProjectsProjectIdIndexRoute,
    SecureProjectsProjectIdGraphIndexRoute:
      SecureProjectsProjectIdGraphIndexRoute,
    SecureProjectsProjectIdObjectsIndexRoute:
      SecureProjectsProjectIdObjectsIndexRoute,
  }

const SecureProjectsProjectIdRouteWithChildren =
  SecureProjectsProjectIdRoute._addFileChildren(
    SecureProjectsProjectIdRouteChildren,
  )

interface SecureRouteChildren {
  SecureMainRoute: typeof SecureMainRouteWithChildren
  SecureSettingsRoute: typeof SecureSettingsRouteWithChildren
  SecureWorkspaceInviteRoute: typeof SecureWorkspaceInviteRoute
  SecureProjectsProjectIdRoute: typeof SecureProjectsProjectIdRouteWithChildren
  SecureSlackConfirmRoute: typeof SecureSlackConfirmRoute
  SecureSlackOauthRoute: typeof SecureSlackOauthRoute
}

const SecureRouteChildren: SecureRouteChildren = {
  SecureMainRoute: SecureMainRouteWithChildren,
  SecureSettingsRoute: SecureSettingsRouteWithChildren,
  SecureWorkspaceInviteRoute: SecureWorkspaceInviteRoute,
  SecureProjectsProjectIdRoute: SecureProjectsProjectIdRouteWithChildren,
  SecureSlackConfirmRoute: SecureSlackConfirmRoute,
  SecureSlackOauthRoute: SecureSlackOauthRoute,
}

const SecureRouteWithChildren =
  SecureRoute._addFileChildren(SecureRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  SecureRoute: SecureRouteWithChildren,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
